export enum ETypes {
  ANNUAL = 'ANNUAL', // Entretien annuel
  DAY_RATE = 'DAY_RATE', // Entretien forfait jour
  DISCONNECT = 'DISCONNECT', // Entretien de droit à la déconnexion
  END_OF_TRIAL = 'END_OF_TRIAL', // Entretien de fin de période d'essai
  PROFESSIONAL = 'PROFESSIONAL', // Entretien professionnel
  RETURN = 'RETURN', // Entretien de retour suite à une absence
  SIX_YEARS = 'SIX_YEARS', // Bilan des six ans
  INTERNAL_MOBILITY_FOLLOW_UP = 'INTERNAL_MOBILITY_FOLLOW_UP', // Suivi de mobilité interne
  OFF_BOARDING = 'OFF_BOARDING', // Fin de contrat
  TRIAL_PERIOD_FOLLOW_UP = 'TRIAL_PERIOD_FOLLOW_UP', // suivi de fin de période d'essai
  CAREER_DEVELOPMENT = 'CAREER_DEVELOPMENT', // entretien de parcours professionnel
  PROGRESS = 'PROGRESS', // entretien d'état des lieux
  MID_CAREER = 'MID_CAREER', // entretien de mi-carrière
  PRE_60_CAREER = 'PRE_60_CAREER', // entretien avant les 60 ans
}

export interface IType {
  id: string;
  createdAt: Date;
  updatedAt: Date | null;
  archivedAt: Date | null;
  type: ETypes;
}

export interface IFindType {
  type?: ETypes;
}
